import endpoints, { axios } from "../config/api";

function deleteTaskTemplate(taskTemplateId: number) {
  return axios.delete(endpoints.taskTemplates.delete(taskTemplateId));
}

export default deleteTaskTemplate;
